<!--suppress TypeScriptUnresolvedFunction, TypeScriptUnresolvedVariable -->
<div fxLayout="column" class="modbus-config-container">
    <div fxLayout="row" fxLayoutAlign="center" class="mb-16">
        <span>{{'Type'|i18n}}: <strong>{{cfg.type|connectorType}}</strong></span>
    </div>
    <div fxLayout="row" fxLayoutAlign="center">
        <form novalidate [formGroup]="form" fxLayout="column" fxLayoutGap="0.5rem" fxFlex="50" class="modbus-form">
        </form>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Gateways'}}</app-divider>
    <div fxLayout="row" class="mt-8">
        <div fxFlex="50" fxFlexOffset="25" fxLayoutAlign="center">
            <button mat-stroked-button color="primary" class="add-gateway-button"
                    (click)="onClickAddGateway()">
                <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
                {{'Add gateway'|i18n}}
            </button>
        </div>
        <div fxFlex fxLayoutAlign="end">
            <button mat-stroked-button color="primary"
                    (click)="onClickAddGatewayFromTemplate()">
                <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
                {{'Add from template'|i18n}}
            </button>
        </div>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedGws|async as gws">
            <ng-container *ngIf="gws">
                <div *ngFor="let gateway of gws.data; trackBy: trackByGatewayId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{gateway.gatewayId}}</em>
                    </div>
                    <form novalidate [formGroup]="gateway.form" fxLayoutAlign="center" fxFlex="shrink"
                          fxLayoutGap="0.5rem"
                          class="gateway-form">
                        <mat-form-field>
                            <input matInput placeholder="{{'Host'|i18n}}" formControlName="host">
                            <mat-error *ngIf="!gateway.form.controls.host.valid">
                                {{'Invalid host'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field class="port-field">
                            <input matInput placeholder="{{'Port'|i18n}}" formControlName="port" type="number">
                            <mat-error *ngIf="!gateway.form.controls.port.valid">
                                {{'Invalid port'|i18n}}
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-select placeholder="{{'Frame type'|i18n}}" formControlName="frame">
                                <mat-option *ngFor="let frameType of MODBUS_FRAME_TYPES" [value]="frameType">
                                    {{frameType|modbusFrameType}}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="!gateway.form.controls.frame.valid">
                                {{'Invalid frame type'|i18n}}
                            </mat-error>
                        </mat-form-field>
                    </form>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [title]="'Advanced settings'|i18n"
                                (click)="onClickGatewayAdvancedSettings(gateway)">
                            <app-icon name="fal-tools"></app-icon>
                        </button>
                        <button class="operation-button" [title]="'Rename gateway'|i18n"
                                (click)="onClickRenameGateway(gateway.gatewayId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove gateway'|i18n"
                                (click)="onClickDeleteGateway(gateway.gatewayId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #gwsPaginator app-paginator class="modbus-paginator"
                           [ngClass]="{'collapsed': !gws || gws.total === 0}"
                           [length]="gws?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
    <app-divider class="mt-8 mb-8" gap="0.5rem">{{'Devices'|i18n}}</app-divider>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-8">
        <button mat-stroked-button color="primary" class="add-device-button"
                (click)="onClickAddDevice()">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add device'|i18n}}
        </button>
    </div>
    <div fxLayout="column" fxLayoutGap="8px" class="mt-16">
        <ng-container *appVar="pagedDevs|async as devs">
            <ng-container *ngIf="devs">
                <div *ngFor="let dev of devs.data; trackBy: trackByDevId"
                     fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="1.5rem">
                    <div fxLayoutAlign="end" fxFlex="grow">
                        <em>{{dev.devId}}</em>
                    </div>
                    <div fxLayoutAlign="center" fxFlex="shrink" fxLayoutGap="0.5rem">
                        <form novalidate [formGroup]="dev.form" fxLayoutGap="0.5rem" class="device-form">
                            <mat-form-field fxFlex="grow">
                                <mat-select placeholder="{{'Gateway'|i18n}}" formControlName="gatewayId">
                                    <mat-option *ngFor="let gateway of gateways; trackBy: trackByGatewayId"
                                                [value]="gateway.gatewayId">
                                        {{gateway.gatewayId}}
                                    </mat-option>
                                </mat-select>
                                <mat-error *ngIf="!dev.form.controls.gatewayId.valid">
                                    {{'Invalid gateway'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field fxFlex="grow">
                                <input matInput placeholder="{{'Register'|i18n}}" formControlName="register"
                                       [title]="'Multiple registers are comma-separated'|i18n">
                                <mat-error
                                        *ngIf="dev.form.controls.register.hasError('empty') || dev.form.controls.register.hasError('not_integer_array')">
                                    {{'Invalid register'|i18n}}
                                </mat-error>
                                <mat-error *ngIf="dev.form.controls.register.hasError('bad_expression')">
                                    {{'Multiple registers need expression'|i18n}}
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field class="uom-field">
                                <input matInput placeholder="{{'UoM'|i18n}}" formControlName="uom"
                                       [title]="'Unit of measure'|i18n">
                                <mat-error *ngIf="!dev.form.controls.uom.valid">
                                    {{'Invalid UoM'|i18n}}
                                </mat-error>
                            </mat-form-field>
                        </form>
                        <div fxFlexAlign="center">
                            <button mat-stroked-button class="polling-policy-btn" [title]="'Polling policy'|i18n"
                                    (click)="onClickDevicePollingPolicy(dev.devId)">
                        <span class="polling-policy-text">
                            <app-icon name="fal-stopwatch"></app-icon>&nbsp;
                            {{cfg.devices[dev.devId]|pollingPolicy}}
                        </span>
                            </button>
                        </div>
                    </div>
                    <div fxLayoutAlign="start" fxFlex="grow" fxLayoutGap="0.5rem">
                        <button class="operation-button" [title]="'Advanced settings'|i18n"
                                (click)="onClickDeviceAdvancedSettings(dev)">
                            <app-icon name="fal-tools"></app-icon>
                        </button>
                        <button class="operation-button" [title]="'Rename device'|i18n"
                                (click)="onClickRenameDevice(dev.devId)">
                            <app-icon name="fal-edit"></app-icon>
                        </button>
                        <button class="operation-button warn" [title]="'Remove device'|i18n"
                                (click)="onClickDeleteDevice(dev.devId)">
                            <app-icon name="fal-trash-alt"></app-icon>
                        </button>
                    </div>
                </div>
            </ng-container>
            <mat-paginator #devsPaginator app-paginator class="modbus-paginator"
                           [ngClass]="{'collapsed': !devs || devs.total === 0}"
                           [length]="devs?.total" [pageSize]="PAGE_SIZE"
                           [pageSizeOptions]="PAGE_SIZES">
            </mat-paginator>
        </ng-container>
    </div>
</div>

<ng-template #addGateway let-data>
    <h1 mat-dialog-title>{{'Add gateway'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #addGatewayFromTemplate let-data>
    <h1 mat-dialog-title>{{'Add gateway from template'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column" class="add-gateway-from-template">
        <form [formGroup]="data['form']" fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" formControlName="id">
                <mat-error *ngIf="data['form'].controls.id.hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['form'].controls.id.hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
                <mat-error
                        *ngIf="data['form'].controls.id.hasError('duplicate_dev') && !data['form'].controls.id.hasError('duplicate')">
                    {{'Device already exists'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Template'|i18n}}" formControlName="template">
                    <mat-option *ngFor="let template of MODBUS_TEMPLATES" [value]="template">
                        {{{type: template.entityType, sub_type: template.entitySubType}|entityType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.template.valid">
                    {{'Invalid template'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
        <ng-container *appVar="data['deviceNamesGenerator']() as devs">
            <span *ngIf="devs.length" class="devices">
                {{'Devices'|i18n}}: {{(devs|sortArray).join(', ')}}
            </span>
        </ng-container>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['form'].valid"
                [mat-dialog-close]="true">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameGateway let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['gatewayId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="rename-gateway">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs">
            {{'Devices connected to {0}'|i18n:data['gatewayId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs">
            {{'No devices connected to {0}'|i18n:data['gatewayId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteGateway let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['gatewayId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="delete-gateway">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['gatewayId']}}</span>
        <span *ngIf="data['connectedDevs'].length" class="connected-devs mt-16">
            {{'Devices connected to {0}'|i18n:data['gatewayId']}}:
            {{(data['connectedDevs']|sortArray).join(', ')}}
        </span>
        <span *ngIf="!data['connectedDevs'].length" class="connected-devs mt-16">
            {{'No devices connected to {0}'|i18n:data['gatewayId']}}
        </span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-8">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #advancedGatewaySettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['gatewayId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="gateway-advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <mat-form-field>
                <input matInput placeholder="{{'Timeout'|i18n}}" formControlName="timeout" type="number">
                <span matSuffix>{{'seconds'|i18n}}</span>
                <mat-error *ngIf="!data['form'].controls.timeout.valid">
                    {{'Invalid timeout'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <input matInput placeholder="{{'Retries'|i18n}}" formControlName="retries" type="number">
                <mat-error *ngIf="!data['form'].controls.retries.valid">
                    {{'Invalid retries'|i18n}}
                </mat-error>
            </mat-form-field>
            <div fxLayout="row" fxLayoutAlign="space-between" class="retry-on-empty">
                <mat-label>{{'Retry on empty'|i18n}}</mat-label>
                <mat-checkbox formControlName="retryOnEmpty" color="primary"></mat-checkbox>
            </div>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #addDevice let-data>
    <h1 mat-dialog-title>{{'Add device'|i18n}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field class="mr-16">
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-plus-square"></app-icon>&nbsp;&nbsp;
            {{'Add'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #renameDevice let-data>
    <h1 mat-dialog-title>{{'Rename {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <form fxLayout="column">
            <mat-form-field>
                <input matInput [placeholder]="'Id'|i18n" [formControl]="data['idFormControl']">
                <mat-error *ngIf="data['idFormControl'].hasError('empty')">
                    {{'Id not valid'|i18n}}
                </mat-error>
                <mat-error *ngIf="data['idFormControl'].hasError('duplicate')">
                    {{'Id already exists'|i18n}}
                </mat-error>
            </mat-form-field>
        </form>
    </div>
    <div mat-dialog-actions class="dialog-actions">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data['idFormControl'].valid"
                [mat-dialog-close]="data['idFormControl'].value">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Rename'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #deleteDevice let-data>
    <h1 mat-dialog-title>{{'Delete {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column">
        <span>{{'Are you sure you want to delete {0}?'|i18n:data['devId']}}</span>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="warn" type="submit"
                [mat-dialog-close]="true">
            <app-icon name="fal-trash-alt"></app-icon>&nbsp;&nbsp;
            {{'Delete'|i18n}}
        </button>
    </div>
</ng-template>

<ng-template #advancedDeviceSettings let-data>
    <h1 mat-dialog-title>{{'Advanced settings for {0}'|i18n:data['devId']}}</h1>
    <div mat-dialog-content fxLayout="column" class="advanced-settings">
        <form novalidate [formGroup]="data['form']" fxLayout="column">
            <mat-form-field>
                <input matInput placeholder="{{'Unit'|i18n}}" formControlName="address" type="number">
                <mat-error *ngIf="!data['form'].controls.address.valid">
                    {{'Invalid unit'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Data type'|i18n}}" formControlName="dataType">
                    <mat-option *ngFor="let dataType of MODBUS_DATA_TYPES" [value]="dataType">
                        {{dataType|modbusDataType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.dataType.valid">
                    {{'Invalid data type'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Register type'|i18n}}" formControlName="regType">
                    <mat-option *ngFor="let regType of MODBUS_REG_TYPES" [value]="regType">
                        {{regType|modbusRegType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.regType.valid">
                    {{'Invalid register type'|i18n}}
                </mat-error>
            </mat-form-field>
            <mat-form-field>
                <mat-select placeholder="{{'Endianness'|i18n}}" formControlName="word">
                    <mat-option *ngFor="let word of MODBUS_WORD_TYPES" [value]="word">
                        {{word|modbusWordType}}
                    </mat-option>
                </mat-select>
                <mat-error *ngIf="!data['form'].controls.word.valid">
                    {{'Invalid endianness'|i18n}}
                </mat-error>
            </mat-form-field>
            <span class="expression-label">
                {{'Expression'|i18n}}
            </span>
            <app-expression-editor formControlName="expression"
                                   [features]="data['features']">
            </app-expression-editor>
            <span *ngIf="data['form'].controls.expression.hasError('bad_expression')" class="expression-error">
                {{'Invalid expression for multi-register device'|i18n}}
            </span>
        </form>
        <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1rem" class="mt-8">
            <span *ngIf="data['registers'].length" class="registers">
                {{'Registers'|i18n}}: {{data['registers'].join(', ')}}
            </span>
            <app-icon name="fal-question-circle" class="expression-help"
                      [matTooltip]="EXPRESSION_HELP|i18n"
                      matTooltipClass="fs-1">
            </app-icon>
        </div>
    </div>
    <div mat-dialog-actions class="dialog-actions mt-16">
        <button mat-stroked-button color="primary" type="submit"
                [disabled]="!data.form.valid || !data.form.dirty"
                [mat-dialog-close]="true">
            <app-icon name="fal-save"></app-icon>&nbsp;&nbsp;
            {{'Ok'|i18n}}
        </button>
    </div>
</ng-template>
